import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const NoContentContainer = styled.div`
    padding: 64px 0;
    text-align: center;
    width: 100%;
`;

export const ZamboniIconContainer = styled.div`
    svg {
        fill: ${({ theme }) => theme.Text.disabled};
        font-size: 54px;
    }
`;

export const NoContentMessageWrapper = styled.div`
    color: ${({ theme }) => theme.Text.secondary};
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle1};
`;

export const ViewHighlightsMessageWrapper = styled.div`
    color: ${({ theme }) => theme.Text.secondary};
    ${BaseStyle.Mixins.fontStyles.desktop.body1};
    padding-top: 8px;

    a {
        color: ${({ theme }) => theme.Utility.cta};
        text-decoration: underline;
    }
`;

export const NewsletterSignUp = styled.div`
    padding-top: 24px;
    color: ${({ theme }) => theme.Text.secondary};
    ${BaseStyle.Mixins.fontStyles.desktop.body3};
`;

// && for higher priority
export const NewsletterSignUpLink = styled.a`
    && {
        color: ${({ theme }) => theme.Utility.cta};
        ${BaseStyle.Mixins.fontStyles.desktop.subtitle3};
        text-decoration: underline;
    }
`;
